module.exports = __webpack_public_path__ + "static/media/back.4d2515bd.svg";